import { render, staticRenderFns } from "./rate_plans.vue?vue&type=template&id=0894556c&scoped=true&"
import script from "./rate_plans.vue?vue&type=script&lang=js&"
export * from "./rate_plans.vue?vue&type=script&lang=js&"
import style0 from "./rate_plans.vue?vue&type=style&index=0&id=0894556c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0894556c",
  null
  
)

export default component.exports